import { APIGatewayProxyEventV2, APIGatewayProxyResultV2 } from "aws-lambda";
import { PageHandlerRequest, PageRequestHandler, PageRequestWebhookMap } from "./types";

export class PageRequestWebhook {
  private _pageHookHandlers: PageRequestWebhookMap;

  constructor(pageHookHandlers: PageRequestWebhookMap) {
    this._pageHookHandlers = pageHookHandlers;
  }

  /**
   * Get the page request handler mapping
   */
  public getPageRequestHandlers(): PageRequestWebhookMap {
    return this._pageHookHandlers;
  }

  /**
   * Add a page to the Webhook after initialization
   */
  public addPageRequestHandler(pageName: string, handler: PageRequestHandler<unknown>): void {
    // TODO - Check if exists and don't allow overwrites?
    this._pageHookHandlers[pageName] = handler;
  }

  /**
   * Entry point handler to be used by Lambda
   */
  public handler() {
    return async (event: APIGatewayProxyEventV2) => await this._handler(event, this._pageHookHandlers);
  }

  private async _handler(
    event: APIGatewayProxyEventV2,
    pageHookHandlers: PageRequestWebhookMap
  ): Promise<APIGatewayProxyResultV2> {
    // TODO: Validate the event
    const { body } = event;

    if (!body) {
      return {
        statusCode: 200,
      };
    }

    const request = JSON.parse(body) as PageHandlerRequest;

    if (!request.pageName) {
      return {
        statusCode: 400,
        body: "You must include pageName in the request.",
      };
    }

    const pageHookHandler = pageHookHandlers[request.pageName];

    if (!pageHookHandler) {
      return {
        statusCode: 404,
        body: `Could not find page with name ${request.pageName}.`,
      };
    }

    try {
      const pageHookData = await pageHookHandler(request);

      return {
        statusCode: 200,
        body: JSON.stringify(pageHookData),
      };
    } catch (e: unknown) {
      if (e instanceof Error) {
        console.error("There was an error getting the page hook data.", e);
      }

      return {
        statusCode: 500,
      };
    }
  }
}
